import { ProjectRenderer } from '../ProjectRenderer';
import { ProjectPlane } from '../objects/ProjectPlane';
import { GridHelper } from 'three';
import RENDERER_CONFIG from '@/configs/rendererConfig';

export class Grid {
	gridHelper: GridHelper | null = null;

	constructor(private renderer: ProjectRenderer, private plane: ProjectPlane) {}

	createGrid() {
		this.gridHelper?.dispose();

		this.gridHelper = new GridHelper(
			RENDERER_CONFIG.GRID.SIZE,
			RENDERER_CONFIG.GRID.SIZE,
			RENDERER_CONFIG.GRID.COLOR,
			RENDERER_CONFIG.GRID.COLOR
		);
		this.gridHelper.position.setY(RENDERER_CONFIG.GRID.POS_Y);
		this.gridHelper.layers.set(RENDERER_CONFIG.GRID.LAYER);

		this.renderer.scene.add(this.gridHelper);
	}
}
